/**
 * Determines the watermark config input for an albumUpdate or albumFolderUpdate.
 *
 * @param {Object} [watermark] The existing watermark config.
 * @returns {null|undefined|{asset_image_id: string, placement: (*|null)}}
 */
export const getWatermarkConfigInput = watermark => {
  // Delete watermark or empty
  if (!watermark?.asset_image?.id) {
    return null;
  }

  // Existing watermark.
  if (watermark?.asset_image?.url && !watermark?.is_new) {
    if (!watermark.asset_image?.id) {
      // Fallback to old way (which didn't work as it doesn't update the placement):
      return undefined;
    }

    return {
      existing_asset_image_id: watermark.asset_image.id,
      placement: watermark.placement || null,
    };
  }

  // Newly created asset image / watermark
  return {
    asset_image_id: watermark.asset_image.id,
    placement: watermark.placement || null,
  };
};
